import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf123216"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-refresh-results" }
const _hoisted_2 = { class: "b-refresh-results__content" }
const _hoisted_3 = { class: "b-refresh-results__content_text" }
const _hoisted_4 = { class: "bold color--text-primary fs-md" }
const _hoisted_5 = { class: "inter-regular color--text-secondary fs-sm" }
const _hoisted_6 = { class: "b-refresh-results__footer" }

import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';
  import { getCleanedQuery } from '@/utils';
  import { Modal } from '@/views/V2/components/Modal';
  import PushButton from '@/views/V2/components/PushButton.vue';
  import SmileFaceIcon from '@/views/V2/icons/SmileFace.vue';
  import '@/assets/v2/index.css';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeModal',
  setup(__props) {

  const { t } = useI18n();
  const store = useStore();
  const router = useRouter();

  const isShown = computed<boolean>(
    () => store.state.support.welcomeDialog.isShown,
  );
  const name = computed<boolean>(() => store.state.support.welcomeDialog.name);

  function handleOnClose() {
    store.commit('support/toggleWelcomeDialog', { isShown: false });

    const query = getCleanedQuery(['name']);
    router.replace({
      path: window.location.pathname,
      query,
    });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), { isOpen: _unref(isShown) }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SmileFaceIcon),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('welcomeDialog.title', { name: _unref(name) })), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('welcomeDialog.text')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(PushButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOnClose()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('welcomeDialog.btn')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}
}

})